module.exports = __webpack_public_path__ + "static/img/qr_code.c4b6536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr_code.png
// module id = XKKh
// module chunks = 1